import React, { FC } from 'react';

import { Icon } from '@iconify/react';
import clsx from 'clsx';

import styles from './styles.module.scss';

type Props = {
  text: string;
  isChecked: boolean;
  children?: JSX.Element;
  className?: string;
};
const StepButton: FC<Props> = ({ text, isChecked, children, className }) => {
  return (
    <div
      className={clsx(
        styles.main,
        { [styles['main--checked']]: isChecked },
        className,
      )}
    >
      {isChecked && (
        <Icon
          className={styles.main__check_mark}
          icon="material-symbols:check-circle"
        />
      )}
      <span className={styles.main__text}>{text}</span>
      {!isChecked && children}
    </div>
  );
};

export default StepButton;
